import React, { Fragment, useEffect, useLayoutEffect, useMemo, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import MpgInput from "../../../../CommonFormComp/MpgInput";
import MpgItem from "../../../../CommonFormComp/MpgItem";
import MpgAutocompleteSingle from "../../../../CommonFormComp/MpgAutocompleteSingle";
import { adminUserViewPath, clientUserViewPath } from "../../../../routes/routePaths";
import MpgErrorDialog from "../../../../common/dialog/MpgErrorDialog";
import MpgLoadingDialog from "../../../../common/dialog/MpgLoadingDialog";
import MpgAutocompleteMulti from "../../../../CommonFormComp/MpgAutocompleteMulti";
import { useGetLoggedInUserDetails } from "../../../../hooksAndFunctions/customHooks/useGetLoggedInUserDetails";
import { editAdminUserValidation } from "./editAdminUserValidation";
import { useUpdateAdminUserMutation, useGetCountryListByLocaleQuery, useGetCountrySpecificLanguageListByCountryCodeQuery, useGetCronofyServiceAccountDataQuery, useGetCronofyTimeZoneDataByCountryCodeQuery, useGetServiceOfficeListByCountryCodesQuery } from "../../../../reactQueries/AppApi/rqHooksForAdminUser";
import { useGetWorkingHoursList } from "../../../../hooksAndFunctions/customHooks/useGetWorkingHoursList";
import { useGetDayListOfWeek } from "../../../../hooksAndFunctions/customHooks/useGetDayListOfWeek";
import { useGetAdminRoleGrouping } from "../../../../hooksAndFunctions/customHooks/useGetAdminRoleGrouping";
import MpgCheckbox from "../../../../CommonFormComp/MpgCheckbox";
import { useAccessTypes } from "../../../../hooksAndFunctions/customHooks/useAccessTypes";
import useTrackUserActivityUsingPhaseOneAPI from "../../../../userActivityTracking/useTrackUserActivityUsingPhaseOneAPI";
import useTrackUserActivity from "../../../../userActivityTracking/useTrackUserActivity";
import sortBy from "lodash/sortBy";
import AdminUserProfileSection from "../AdminUserProfileSection";


const EditAdminUser = ({ adminUserDataById, timezonesListForAdminUser,
  countryListForRTByLocale,adminUserCMSData }) => {
  let navigate = useNavigate();

  // console.log("xxx-adminUserDataById:", adminUserDataById)

  const { loggedInUser } = useGetLoggedInUserDetails();
  const { activeDirectoryId, lastName, firstName } = loggedInUser;

  const access = useAccessTypes()
  const {
    isEnterpriseAdmin: isEnterpriseAdminType,
    clientPortalAdminType,
    candidatePortalAdminType,
  } = access
  const { isClientPortalAdmin, hasA1Access, hasA2Access, hasA3Access } = clientPortalAdminType
  const { isCandidatePortalAdmin, hasSuperAdminAccess, hasAdminAccess, hasCoachAccess, hasCoachAdminAccess } = candidatePortalAdminType

  const userName = `${lastName} ${firstName}`

  // schema validations
  let { schema } =   useMemo(() =>  editAdminUserValidation(adminUserCMSData?.pageContent["AdminUserValidationMsg"]?.Labels), [adminUserCMSData]);

  const rhfFormInstance = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      enterprise_admin_check: adminUserDataById?.isEnterpriseAdmin || false,
      first_name: adminUserDataById?.firstName || "",
      last_name: adminUserDataById?.lastName || "",
      // preferred_name: adminUserDataById?.firstName || "",
      email: adminUserDataById?.emailAddress || "",
      affiliate_email: adminUserDataById?.affiliateEmailAddress || "",
      preferred_number: adminUserDataById?.primaryContactNo || "",
    }
  });

  const { watch, setValue } = rhfFormInstance;

  const selectedCountryByLocaleFromUserDetails = watch("country_user_details");
  const selectedCountryByLocaleFromUserRoles = watch("country_user_role");
  const selectedEnterpriseAdminCheck = watch("enterprise_admin_check");

  const selectedCandidatePortalRole = watch("candidate_portal_role");
  const selectedClientPortalRole = watch("client_portal_role");
  const email = watch("email")
  const adminUserFullName = `${watch("last_name")} ${watch("first_name")}`

  const [showCoachRelatedContent, setShowCoachRelatedContent] = useState(false)
  useEffect(() => {
    if (
      selectedCandidatePortalRole?.selectOptionLabel === "Coach" ||
      selectedCandidatePortalRole?.selectOptionLabel === "Coach Admin"
    ) {
      setShowCoachRelatedContent(true)
    } else {

      setShowCoachRelatedContent(false)
      /**clear all coach related fields*/
      setValue("bio_user_profile", "");
      setValue("expertise", "");
      setValue("language_user_profile", "");
      setValue("linkedIn_id", "");
      setValue("twitter_id", "");

      setValue("time_zone_cronofy", "");
      setValue("service_account_name_cronofy", "");
      setValue("available_days", "");
      setValue("working_hours_start_time", "");
      setValue("working_hours_end_time", "");
    }
  }, [selectedCandidatePortalRole])


  const fetchAdminUserDetailsLabel = (key) => {
    if (adminUserCMSData && adminUserCMSData?.pageContent["AdminUserDetails"]) {
        const adminUserCMSDataLabel = adminUserCMSData.pageContent["AdminUserDetails"];
        return returnLabel(adminUserCMSDataLabel?.Labels, key)
    }
    return '';
  }
  const fetchAdminUserRolesLabel = (key) => {
  if (adminUserCMSData && adminUserCMSData?.pageContent["AdminUserRoles"]) {
      const adminUserCMSDataLabel = adminUserCMSData.pageContent["AdminUserRoles"];
      return returnLabel(adminUserCMSDataLabel?.Labels, key)
  }
  return '';
}

const fetchAdminUserProfileLabel = (key) => {
  if (adminUserCMSData && adminUserCMSData?.pageContent["AdminUserProfile"]) {
      const adminUserCMSDataLabel = adminUserCMSData.pageContent["AdminUserProfile"];
      return returnLabel(adminUserCMSDataLabel?.Labels, key)
  }
  return '';
}

const fetchCronofySectionLabel = (key) => {
  if (adminUserCMSData && adminUserCMSData?.pageContent["CronofySection"]) {
      const adminUserCMSDataLabel = adminUserCMSData.pageContent["CronofySection"];
      return returnLabel(adminUserCMSDataLabel?.Labels, key)
  }
  return '';
}

const fetchAdminUserValidationLabel = (key) => {
  if (adminUserCMSData && adminUserCMSData?.pageContent["AdminUserValidationMsg"]) {
    const adminUserCMSDataLabel = adminUserCMSData.pageContent["AdminUserValidationMsg"];
    return returnLabel(adminUserCMSDataLabel?.Labels, key)
}
return '';
}

  const returnLabel = (labelArray=[], key) => {
        return labelArray.find((x) => x.Key === key)?.Phrase || '';
  }


  /**get countrySpLangListByCountryCode */
  const {
    isSuccess: isSuccessOnCountrySpLangListByCountryCode,
    isFetching: isFetchingOnCountrySpLangListByCountryCode,
    error: errorOnCountrySpLangListByCountryCode,
    isError: isErrorOnCountrySpLangListByCountryCode,
    data: countrySpLangListByCountryCode,
  } = useGetCountrySpecificLanguageListByCountryCodeQuery({ countryCode: selectedCountryByLocaleFromUserDetails?.id });

  /**get ServiceOfficeListByCountryCodes for user details*/
  const {
    isSuccess: isSuccessOnUserDetailServiceOfficeList,
    isFetching: isFetchingOnUserDetailServiceOfficeList,
    error: errorOnUserDetailServiceOfficeList,
    isError: isErrorOnUserDetailServiceOfficeList,
    data: serviceOfficeListForUserDetails,
  } = useGetServiceOfficeListByCountryCodesQuery({ countryCodes: selectedCountryByLocaleFromUserDetails?.id });

  /**get ServiceOfficeListByCountryCodes for user roles*/
  let countryCodeArray = []
  if (!!selectedCountryByLocaleFromUserRoles) {
    selectedCountryByLocaleFromUserRoles.forEach((eachItem) => {
      countryCodeArray.push(eachItem?.id)
    })
  }
  const {
    isSuccess: isSuccessOnUserRolesServiceOfficeList,
    isFetching: isFetchingOnUserRolesServiceOfficeList,
    error: errorOnUserRolesServiceOfficeList,
    isError: isErrorOnUserRolesServiceOfficeList,
    data: serviceOfficeListForUserRoles,
  } = useGetServiceOfficeListByCountryCodesQuery({ countryCodes: countryCodeArray.toString() });

  const { hoursList } = useGetWorkingHoursList()

  const { weekDays } = useGetDayListOfWeek()

  const {
    isSuccess: isSuccessOnCronofyTimeZone,
    isFetching: isFetchingOnCronofyTimeZone,
    error: errorOnCronofyTimeZone,
    isError: isErrorOnCronofyTimeZone,
    data: cronofyTimeZone,
  } = useGetCronofyTimeZoneDataByCountryCodeQuery({ countryCode: selectedCountryByLocaleFromUserDetails?.id })

  const {
    isSuccess: isSuccessOnServiceAccountData,
    isFetching: isFetchingOnServiceAccountData,
    error: errorOnServiceAccountData,
    isError: isErrorOnServiceAccountData,
    data: serviceAccountData,
  } = useGetCronofyServiceAccountDataQuery()


  // api - create client user mutation
  const {
    mutate: updateAdminUser,
    isError: isErrorOnUpdate,
    isLoading: isLoadingOnUpdate,
    isSuccess: isSuccessOnUpdate,
    data: dataOnUpdate,
    error: errorOnUpdate,
  } = useUpdateAdminUserMutation();

  const { enterpriseAdminRolesGrp, candidatePortalRolesGrp, clientPortalRolesGrp } = useGetAdminRoleGrouping()


  /** !!!!!!!! autocomplete option lists !!!!!!! */
  const timezonesAutocompleteList = !!timezonesListForAdminUser && timezonesListForAdminUser.map((item) => {
    return {
      id: item.id,
      selectOptionLabel: item.title,
      selectOptionValue: item.id,
      extraData: item
    }
  })

  const weekDaysAutocompleteList = !!weekDays && weekDays.map((item) => {
    return {
      id: item.label,
      selectOptionLabel: item.label,
      selectOptionValue: item.value,
      extraData: item
    }
  })
  const hoursListAutocompleteList = !!hoursList && hoursList.map((item) => {
    return {
      id: item.label,
      selectOptionLabel: item.label,
      selectOptionValue: item.label,
      extraData: item
    }
  })

  const countryListByLocaleAutocompleteList = !!countryListForRTByLocale && countryListForRTByLocale.map((item) => {
    const standardCodesList = item?.standardCodes
    const standardCodesListonlyForRT = !!standardCodesList && standardCodesList.find((eachItem) => {
      if (eachItem?.itemCodeStandardName === "rt") {
        return eachItem
      }
    })
    return {
      id: standardCodesListonlyForRT?.standardCodeValue || "",
      selectOptionLabel: item.title,
      selectOptionValue: standardCodesListonlyForRT?.standardCodeValue || "",
      extraData: item
    }
  })

  const countrySpLangAutocompleteList = !!countrySpLangListByCountryCode && countrySpLangListByCountryCode.map((item) => {
    return {
      id: item.localeName,
      selectOptionLabel: item.localeName,
      selectOptionValue: item.localeName,
      extraData: item
    }
  })

  const serviceOfficeListForUserDetailsAutocompleteList = !!serviceOfficeListForUserDetails && serviceOfficeListForUserDetails.map((item) => {
    return {
      id: item.rightOfficeId,
      selectOptionLabel: item.rightOfficeName,
      selectOptionValue: item.rightOfficeId,
      extraData: item
    }
  })
  const serviceOfficeListForUserRolesAutocompleteList = !!serviceOfficeListForUserRoles && serviceOfficeListForUserRoles.map((item) => {
    return {
      id: item.rightOfficeId,
      selectOptionLabel: item.rightOfficeName,
      selectOptionValue: item.rightOfficeId,
      extraData: item
    }
  })

  const adminUserStatus = [
    {
      statusTitle: "Active",
      isActive: true,
    },
    {
      statusTitle: "InActive",
      isActive: false,
    }
  ]
  const adminUserStatusAutocompleteList = !!adminUserStatus && adminUserStatus.map((item) => {
    return {
      id: item.statusTitle,
      selectOptionLabel: item.statusTitle,
      selectOptionValue: item.isActive,
      extraData: item
    }
  })

  const cronofyTimeZoneAutocompleteList = !!cronofyTimeZone && cronofyTimeZone.map((item) => {
    return {
      id: item.id,
      selectOptionLabel: item.ianaTimeZoneIdentifier,
      selectOptionValue: item.ianaTimeZoneIdentifier,
      extraData: item
    }
  })

  const serviceAccountDataAutocompleteList = !!serviceAccountData && serviceAccountData.map((item) => {
    return {
      id: item.id,
      selectOptionLabel: item.serviceAccountName,
      selectOptionValue: item.id,
      extraData: item
    }
  })

  const candidatePortalRolesAutocompleteList = !!candidatePortalRolesGrp && candidatePortalRolesGrp.map((item) => {
    return {
      id: item.roleId,
      selectOptionLabel: item.role,
      selectOptionValue: item.roleId,
      extraData: item
    }
  })
  const clientPortalRolesAutocompleteList = !!clientPortalRolesGrp && clientPortalRolesGrp.map((item) => {
    return {
      id: item.roleId,
      selectOptionLabel: item.role,
      selectOptionValue: item.roleId,
      extraData: item
    }
  })
  const sortedClientPortalRolesAutocompleteList = sortBy(clientPortalRolesAutocompleteList, function (item) {
    const role = item?.selectOptionLabel || ""
    /**we are converting all selectOptionLabel into smallcase for proper aphabetical order */
    return [role.toLowerCase()];
  });


  /**set default value for status */
  useEffect(() => {
    setValue("status", adminUserStatusAutocompleteList[0])
  }, [])

  /** Populating values in fields */
  const existingTimeZone = adminUserDataById?.timeZone
  useEffect(() => {

    if (!!existingTimeZone && !!timezonesListForAdminUser && !!timezonesListForAdminUser.length) {
      const foundItem = !!timezonesListForAdminUser && timezonesListForAdminUser.find((item) => item.id === existingTimeZone)
      if (!!foundItem) {
        const val = {
          id: foundItem.id,
          selectOptionLabel: foundItem.title,
          selectOptionValue: foundItem.id,
          extraData: foundItem
        }
        setValue("time_zone", val);
      } else {
        setValue("time_zone", "");
      }
    }
  }, [existingTimeZone, timezonesListForAdminUser])

  const countryCode = adminUserDataById?.countryCode
  const normalizedCountryCode = (countryCode || "").toLowerCase()
  const countryCodesToMatch =
    normalizedCountryCode === "uk" || normalizedCountryCode === "gb"
      ? ["uk", "gb"]
      : [normalizedCountryCode]
  useEffect(() => {

    if (!!countryCode && !!countryListForRTByLocale && !!countryListForRTByLocale.length) {
      const foundCountry = !!countryListForRTByLocale && countryListForRTByLocale.find((item) => {
        const itemCountryCode = (item?.id || "").toLowerCase()
        return countryCodesToMatch.includes(itemCountryCode)
      })

      const standardCodesList = foundCountry?.standardCodes
      const standardCodesListonlyForRT = !!standardCodesList && standardCodesList.find((eachItem) => {
        if (eachItem?.itemCodeStandardName === "rt") {
          return eachItem
        }
      })
      if (!!foundCountry) {
        const val = {
          id: standardCodesListonlyForRT?.standardCodeValue || "",
          selectOptionLabel: foundCountry.title,
          selectOptionValue: standardCodesListonlyForRT?.standardCodeValue || "",
          extraData: foundCountry
        }
        setValue("country_user_details", val);
      } else {
        setValue("country_user_details", "");
      }
    }
  }, [countryCode, countryListForRTByLocale])

  const existingAppLangCode = adminUserDataById?.applicationLanguageCode
  useEffect(() => {
    if (!!existingAppLangCode && !!countrySpLangListByCountryCode && !!countrySpLangListByCountryCode.length) {
      const foundItem = !!countrySpLangListByCountryCode && countrySpLangListByCountryCode.find((item) => item.localeName === existingAppLangCode)
      if (!!foundItem) {
        const val = {
          id: foundItem.localeName,
          selectOptionLabel: foundItem.localeName,
          selectOptionValue: foundItem.localeName,
          extraData: foundItem
        }
        setValue("application_language", val || "");
      }
    }
  }, [existingAppLangCode, countrySpLangListByCountryCode?.length])

  const existingRightOfficeId = adminUserDataById?.rightOfficeId
  useEffect(() => {
    if (!!existingRightOfficeId && !!serviceOfficeListForUserDetails && !!serviceOfficeListForUserDetails.length) {
      const foundItem = !!serviceOfficeListForUserDetails && serviceOfficeListForUserDetails.find((item) => item.rightOfficeId === existingRightOfficeId)
      if (!!foundItem) {
        const val = {
          id: foundItem.rightOfficeId,
          selectOptionLabel: foundItem.rightOfficeName,
          selectOptionValue: foundItem.rightOfficeId,
          extraData: foundItem
        }
        setValue("service_office_user_details", val || "");
      }
    }
  }, [existingAppLangCode, serviceOfficeListForUserDetails?.length])

  const existingIsActive = adminUserDataById?.isActive
  useEffect(() => {
    const foundItem = !!adminUserStatus && adminUserStatus.find((item) => item.isActive === existingIsActive)
    if (!!foundItem) {
      const val = {
        id: foundItem.statusTitle,
        selectOptionLabel: foundItem.statusTitle,
        selectOptionValue: foundItem.isActive,
        extraData: foundItem
      }
      setValue("status", val || "");
    }
  }, [existingIsActive, adminUserStatus?.length])


  /**populating roles */
  const existingAdminUserRoles = adminUserDataById?.adminUserRoles
  const { candidatePortalRole, clientPortalRole, enterpriseRole, serviceOffices } = existingAdminUserRoles

  useEffect(() => {
    if (!!candidatePortalRole.role && !!candidatePortalRolesGrp && !!candidatePortalRolesGrp.length) {
      const foundItem = !!candidatePortalRolesGrp && candidatePortalRolesGrp.find((item) => item.roleId === existingAdminUserRoles.candidatePortalRole.roleId)

      if (!!foundItem) {
        const value = {
          id: foundItem.roleId,
          selectOptionLabel: foundItem.role,
          selectOptionValue: foundItem.roleId,
          extraData: foundItem
        }
        setValue("candidate_portal_role", value || "")
      }
    }
    if (!!clientPortalRole?.role && !!clientPortalRolesGrp && !!clientPortalRolesGrp.length) {
      const foundItem = !!clientPortalRolesGrp && clientPortalRolesGrp.find((item) => item.roleId === clientPortalRole?.roleId)

      if (!!foundItem) {
        const value = {
          id: foundItem.roleId,
          selectOptionLabel: foundItem.role,
          selectOptionValue: foundItem.roleId,
          extraData: foundItem
        }
        setValue("client_portal_role", value || "")
      }
    }
  }, [adminUserDataById, candidatePortalRolesGrp?.length, clientPortalRolesGrp?.length])

  /**populating countries for user roles */
  useEffect(() => {
    if (!!serviceOffices && !!serviceOffices.length && !!countryListForRTByLocale && !!countryListForRTByLocale.length) {
      let countryCodeArray = [] /**["ca","us"] */

      /**get only countrycodes in lower case */
      serviceOffices.forEach((item) => {
        countryCodeArray.push((item.countryCode || "").toLowerCase())
      })

      /**get only unique contryCodes */
      const countryCodeSet = new Set(countryCodeArray)
      const countryCodeWithUniqueValues = Array.from(countryCodeSet)

      let foundCountryObjList = []
      !!countryCodeWithUniqueValues && countryCodeWithUniqueValues.forEach((eachCountryCode) => {
        const countryCodesToMatch =
          eachCountryCode === "uk" || eachCountryCode === "gb"
            ? ["uk", "gb"]
            : [eachCountryCode]

        const foundCountryItem = !!countryListForRTByLocale && countryListForRTByLocale.find((item) => {
          const itemCountryCode = (item?.id || "").toLowerCase()
          return countryCodesToMatch.includes(itemCountryCode)
        })

        const standardCodesList = foundCountryItem?.standardCodes
        const standardCodesListonlyForRT = !!standardCodesList && standardCodesList.find((eachItem) => {
          if (eachItem?.itemCodeStandardName === "rt") {
            return eachItem
          }
        })
        if (!!foundCountryItem) {
          foundCountryObjList.push({
            id: standardCodesListonlyForRT?.standardCodeValue || "",
            selectOptionLabel: foundCountryItem.title,
            selectOptionValue: standardCodesListonlyForRT?.standardCodeValue || "",
            extraData: foundCountryItem
          })
        }
      })
      setValue("country_user_role", foundCountryObjList || [])
    }
  }, [adminUserDataById, countryListForRTByLocale?.length])

  /**populating service offices for user roles */
  useEffect(() => {
    if (!!serviceOffices && !!serviceOffices.length && !!serviceOfficeListForUserRoles && !!serviceOfficeListForUserRoles.length) {
      let rightOfficeIdArray = []/**[23, 35] */

      serviceOffices.forEach((item) => {
        rightOfficeIdArray.push(item.rightOfficeId)
      })

      let serviceOffObjList = []

      !!rightOfficeIdArray && rightOfficeIdArray.forEach((eachRightOfficeId) => {
        const foundItem = !!serviceOfficeListForUserRoles && serviceOfficeListForUserRoles.find((item) => item.rightOfficeId === eachRightOfficeId)

        if (!!foundItem) {
          serviceOffObjList.push({
            id: foundItem.rightOfficeId,
            selectOptionLabel: foundItem.rightOfficeName,
            selectOptionValue: foundItem.rightOfficeId,
            extraData: foundItem
          })
        }
      })
      setValue("service_office_user_role", serviceOffObjList || [])
    }
  }, [adminUserDataById, serviceOfficeListForUserRoles])

  /** */
  const existingChronofyTimeZone = adminUserDataById?.schedulingAvailability?.tzid
  useEffect(() => {
    if (!!showCoachRelatedContent) {

      if (!!existingChronofyTimeZone && !!cronofyTimeZone && !!cronofyTimeZone.length) {
        const foundItem = !!cronofyTimeZone && cronofyTimeZone.find((item) => item.ianaTimeZoneIdentifier === existingChronofyTimeZone)
        if (!!foundItem) {
          const val = {
            id: foundItem.id,
            selectOptionLabel: foundItem.ianaTimeZoneIdentifier,
            selectOptionValue: foundItem.ianaTimeZoneIdentifier,
            extraData: foundItem
          }
          setValue("time_zone_cronofy", val || "");
        }
      }
    } else {
      setValue("time_zone_cronofy", "");
    }
  }, [existingChronofyTimeZone, cronofyTimeZone, showCoachRelatedContent])

  /** */
  const existingChronofyServiceAccId = adminUserDataById?.serviceAccountId
  useEffect(() => {
    if (!!showCoachRelatedContent) {
      if (!!existingChronofyServiceAccId && !!serviceAccountData && !!serviceAccountData.length) {
        const foundItem = !!serviceAccountData && serviceAccountData.find((item) => item.id === existingChronofyServiceAccId)
        if (!!foundItem) {
          const val = {
            id: foundItem.id,
            selectOptionLabel: foundItem.serviceAccountName,
            selectOptionValue: foundItem.id,
            extraData: foundItem
          }
          setValue("service_account_name_cronofy", val || "");
        }
      }
    } else {
      setValue("service_account_name_cronofy", "");
    }
  }, [existingChronofyServiceAccId, serviceAccountData, showCoachRelatedContent])

  /** */
  const existingWeeklyPeriodsArray = adminUserDataById?.schedulingAvailability?.weekly_periods

  let existingDays = []
  !!existingWeeklyPeriodsArray && existingWeeklyPeriodsArray.forEach((item) => {
    existingDays.push(item?.day)
  })
  const existingStartTime = !!existingWeeklyPeriodsArray && existingWeeklyPeriodsArray[0]?.start_time || ""
  const existingEndTime = !!existingWeeklyPeriodsArray && existingWeeklyPeriodsArray[0]?.end_time || ""

  useEffect(() => {
    if (!!showCoachRelatedContent) {
      if (!!existingDays && !!existingDays.length) {
        let dayObjList = []
        !!existingDays && existingDays.forEach((eachDay) => {
          const foundDay = !!weekDays && weekDays.find((item) => item.value === eachDay)
          if (!!foundDay) {
            dayObjList.push({
              id: foundDay.label,
              selectOptionLabel: foundDay.label,
              selectOptionValue: foundDay.value,
              extraData: foundDay
            })
          }
        })
        setValue("available_days", !!dayObjList.length ? dayObjList : []);
      }
    } else {
      setValue("available_days", []);
    }
  }, [existingDays, weekDays, showCoachRelatedContent])

  useEffect(() => {
    if (!!showCoachRelatedContent) {
      if (!!existingStartTime && !!existingEndTime) {
        let startTimeObj = {}
        let endTimeObj = {}
        !!hoursList && hoursList.forEach((eachHr) => {
          if (eachHr?.label === existingStartTime) {
            startTimeObj = {
              id: eachHr.label,
              selectOptionLabel: eachHr.label,
              selectOptionValue: eachHr.label,
              extraData: eachHr
            }
          }
          if (eachHr?.label === existingEndTime) {
            endTimeObj = {
              id: eachHr.label,
              selectOptionLabel: eachHr.label,
              selectOptionValue: eachHr.label,
              extraData: eachHr
            }
          }
        })
        setValue("working_hours_start_time", startTimeObj || "");
        setValue("working_hours_end_time", endTimeObj || "");
      }
    } else {
      setValue("working_hours_start_time", "");
      setValue("working_hours_end_time", "");
    }

  }, [existingStartTime, existingEndTime, hoursList, showCoachRelatedContent])

  useEffect(() => {
    if (!!showCoachRelatedContent) {
      setValue("bio_user_profile", adminUserDataById?.bio || "");
      setValue("expertise", adminUserDataById?.expertise || "");
      setValue("language_user_profile", adminUserDataById?.language || "");
    } else {
      setValue("bio_user_profile", "");
      setValue("expertise", "");
      setValue("language_user_profile", "");
    }
  }, [showCoachRelatedContent, adminUserDataById])

  /** */
  const socialMediaIds = adminUserDataById?.socialIdDetails
  useEffect(() => {
    if (!!showCoachRelatedContent) {
      if (!!socialMediaIds) {
        const socialMediaIdsSplit = socialMediaIds.split(",")

        if (!!socialMediaIdsSplit && !!socialMediaIdsSplit.length) {
          const linkedinId = socialMediaIdsSplit[0]
          const tweeterId = socialMediaIdsSplit[1]

          setValue("linkedIn_id", linkedinId);
          setValue("twitter_id", tweeterId);
        } else {
          setValue("linkedIn_id", "");
          setValue("twitter_id", "");
        }
      }
    } else {
      setValue("linkedIn_id", "");
      setValue("twitter_id", "");
    }
  }, [socialMediaIds, showCoachRelatedContent])

  /** handling disabled fields */
  const [disabledIsEnterpriseAdminRoleBasedOnAccess, setDisabledIsEnterpriseAdminRoleBasedOnAccess] = useState(false)
  const [disabledCandidatePortalRoleBasedOnAccess, setDisabledCandidatePortalRoleBasedOnAccess] = useState(false)
  const [disabledClientPortalRoleBasedOnAccess, setDisabledClientPortalRoleBasedOnAccess] = useState(false)

  // /**for rolebased access disable field */
  useEffect(() => {
    if (!!isEnterpriseAdminType) {
      /**disabled state */
      setDisabledIsEnterpriseAdminRoleBasedOnAccess(false)
      setDisabledCandidatePortalRoleBasedOnAccess(false)
      setDisabledClientPortalRoleBasedOnAccess(false)
    } else {

      setDisabledIsEnterpriseAdminRoleBasedOnAccess(true)

      /**access control for candidate portal */
      if (!!hasSuperAdminAccess) {
        setDisabledCandidatePortalRoleBasedOnAccess(false)
      } else {
        setDisabledCandidatePortalRoleBasedOnAccess(true)
      }
      /**access control for client portal */

      if (!!hasA1Access) {
        setDisabledClientPortalRoleBasedOnAccess(false)
      } else {
        setDisabledClientPortalRoleBasedOnAccess(true)
      }
    }
  }, [isEnterpriseAdminType,
    clientPortalAdminType,
    candidatePortalAdminType])

  /**for form interaction disabled field */
  const [disabledCandidatePortalRoleOnEntRoleCheck, setDisabledCandidatePortalRoleOnEntRoleCheck] = useState(false)
  const [disabledClientPortalRoleOnEntRoleCheck, setDisabledClientPortalRoleOnEntRoleCheck] = useState(false)
  useEffect(() => {
    if (!!selectedEnterpriseAdminCheck) {
      setValue("candidate_portal_role", "")
      setValue("client_portal_role", "")

      setDisabledCandidatePortalRoleOnEntRoleCheck(true)
      setDisabledClientPortalRoleOnEntRoleCheck(true)
    } else {
      setDisabledCandidatePortalRoleOnEntRoleCheck(false)
      setDisabledClientPortalRoleOnEntRoleCheck(false)
    }
  }, [selectedEnterpriseAdminCheck])

  const [disabledApplicationLanguage, setDisabledApplicationLanguage] = useState(false)
  const [disabledServiceOfficeUserDetails, setDisabledServiceOfficeUserDetails] = useState(false)
  const [disabledTimeZoneCronofy, setDisabledTimeZoneCronofy] = useState(false)

  useEffect(() => {
    if (!!selectedCountryByLocaleFromUserDetails?.id) {
      setDisabledApplicationLanguage(false)
      setDisabledServiceOfficeUserDetails(false)
      setDisabledTimeZoneCronofy(false)
    } else {
      setDisabledApplicationLanguage(true)
      setDisabledServiceOfficeUserDetails(true)
      setDisabledTimeZoneCronofy(true)
    }

  }, [selectedCountryByLocaleFromUserDetails?.id])

  const [disabledServiceOffFromUserRoles, setDisabledServiceOffFromUserRoles] = useState(false)
  useEffect(() => {
    if (!!selectedCountryByLocaleFromUserRoles && !!selectedCountryByLocaleFromUserRoles.length) {
      setDisabledServiceOffFromUserRoles(false)
    } else {
      setDisabledServiceOffFromUserRoles(true)
    }

    /**clear value on every country change */
    setValue("service_office_user_role", "")

  }, [selectedCountryByLocaleFromUserRoles])

  /**form handling */
  const onSubmit = (data) => {
    // console.log("data:", data)

    /**common body handling */

    let serviceOfficeArrayFromUserRoles = []
    const serviceOfficesFromRole = data?.service_office_user_role || []

    if (!!serviceOfficesFromRole && !!serviceOfficesFromRole.length) {
      serviceOfficesFromRole.forEach((eachItem) => {
        serviceOfficeArrayFromUserRoles.push({
          ServiceOfficeId: eachItem?.extraData?.rightOfficeId || "",
          ServiceOfficeName: eachItem?.extraData?.rightOfficeName
            || "",
          CountryCode: eachItem?.extraData?.countryCode || "",
        })
      })
    }

    const enterpriseAdminRoleData = enterpriseAdminRolesGrp[0]
    let roles = {
      candidatePortalRole: {
        role: !!data?.candidate_portal_role ? data?.candidate_portal_role?.extraData?.role : "",
        roleId: !!data?.candidate_portal_role ? data?.candidate_portal_role?.extraData?.roleId : "00000000-0000-0000-0000-000000000000",
      },
      clientPortalRole: {
        role: !!data?.client_portal_role ? data?.client_portal_role?.extraData?.role : "",
        roleId: data?.client_portal_role ? data?.client_portal_role?.extraData?.roleId : "00000000-0000-0000-0000-000000000000",
      },
      enterpriseRole: {
        role: !!data?.enterprise_admin_check ? enterpriseAdminRoleData?.role : "",
        roleId: !!data?.enterprise_admin_check ? enterpriseAdminRoleData?.roleId : "00000000-0000-0000-0000-000000000000",
      },
    }

    const commonBody = {
      StaffId: adminUserDataById?.id || "",
      ActiveDirectoryId: activeDirectoryId || "",
      FirstName: data?.first_name || "",
      LastName: data?.last_name || "",
      PreferredName: data?.preferred_name || "",
      AffiliateEmailAddress: data?.affiliate_email || "",
      CountryCode: data?.country_user_details?.selectOptionValue || "",
      EmailAddress: data?.email || "",
      timeZone: data?.time_zone?.id || "",
      ContactNo: data?.preferred_number || "",
      ApplicationLanguage: data?.application_language?.selectOptionLabel || "",
      ServiceOfficeId: data?.service_office_user_details?.extraData?.rightOfficeId || "",
      ServiceOfficeName: data?.service_office_user_details?.extraData?.rightOfficeName || "",
      IsActive: data?.status?.selectOptionValue,
      IsEnterpriseAdmin: data?.enterprise_admin_check || false,
      AdminUserRoles: {
        ...roles,
        serviceOffices: serviceOfficeArrayFromUserRoles || []
      },
      Username: `${data?.last_name},${data?.first_name}`,
      CreatedBy: userName,
    }

    /**coach related body handling */
    let weeklyPeriods = [];

    if (!!data?.available_days) {
      data?.available_days.forEach((item) => {
        weeklyPeriods.push({
          day: item?.selectOptionValue || "",
          start_time: data?.working_hours_start_time?.selectOptionValue || "",
          end_time: data?.working_hours_end_time?.selectOptionValue || "",
        })
      })
    }

    let socialIdDetails = ""
    if (!!data?.linkedIn_id && data?.twitter_id) {
      socialIdDetails = `${data?.linkedIn_id},${data?.twitter_id}`
    } else {
      socialIdDetails = data?.linkedIn_id || data?.twitter_id || ""
    }

    const coachRelatedBody = {
      ServiceAccountId: data?.service_account_name_cronofy?.id || "",
      schedulingAvailability: {
        tzid: data?.time_zone_cronofy?.selectOptionValue
          || "",
        weekly_periods: weeklyPeriods || []
      },
      Bio: data?.bio_user_profile || "",
      Expertise: data?.expertise || "",
      Language: data?.language_user_profile || "",
      SocialIdDetails: socialIdDetails,
    }

    let body = {}

    if (!!showCoachRelatedContent) {
      body = {
        ...commonBody,
        ...coachRelatedBody
      }
    } else {
      body = commonBody
    }

    // console.log("body:", body)

    updateAdminUser({ body });
  };

  useEffect(() => {
    if (!!isSuccessOnUpdate) {
      navigate(adminUserViewPath);
    }
  }, [isSuccessOnUpdate]);


  /**tracking user Activity */
  /**using global track activity APi */
  const { trackActivity } = useTrackUserActivity()
  /**using phase-1 track activity APi  */
  const { trackActivityUsingPhaseOneAPI } = useTrackUserActivityUsingPhaseOneAPI()
  useEffect(() => {
    if (!!isSuccessOnUpdate) {
      trackActivity({
        activitySuccess: !!isSuccessOnUpdate,
        actionType: "Updated",
        itemId: email || "",
      })

      let roles = ""
      if (!!selectedEnterpriseAdminCheck) {
        roles = "Enterprise admin"
      } else {
        if (!!selectedCandidatePortalRole?.selectOptionLabel && !!selectedClientPortalRole?.selectOptionLabel) {
          roles = `${selectedCandidatePortalRole?.selectOptionLabel} and ${selectedClientPortalRole?.selectOptionLabel}`
        } else {
          roles = `${selectedCandidatePortalRole?.selectOptionLabel}` || `${selectedClientPortalRole?.selectOptionLabel}` || ""
        }
      }
      trackActivityUsingPhaseOneAPI({
        activitySuccess: !!isSuccessOnUpdate,
        actionType: "Updated",
        itemId: email || "",
        extraDescription: `${adminUserFullName} as ${roles}`
      })
    }
  }, [isSuccessOnUpdate])

  const [disableUpdateAdminUserButton, setDisableUpdateAdminUserButton] = useState(false)
  useEffect(() => {
    if (!!isEnterpriseAdminType || !!hasA1Access || !!hasSuperAdminAccess) {
      setDisableUpdateAdminUserButton(false)
    } else {
      setDisableUpdateAdminUserButton(true)
    }
  }, [access])

  /**error handling */
  const [errorTitle, setErrorTitle] = useState('')
  const [errorContent, setErrorContent] = useState('')

  useEffect(() => {
    if (!!errorOnUpdate && errorOnUpdate?.response?.data?.errorType === "EmailExists") {
      setErrorTitle(fetchAdminUserValidationLabel('AdminUserValidationMsg.EmailExists'))
      setErrorContent(`"${watch('email')}" ${fetchAdminUserValidationLabel('AdminUserValidationMsg.EmailExistsMsg').replace('*Email*','')}`)
    } else if (!!errorOnUpdate && errorOnUpdate?.response?.data?.errorType === "ValidationError") {
      setErrorTitle(fetchAdminUserValidationLabel('AdminUserValidationMsg.FormValidation'))
      setErrorContent(fetchAdminUserValidationLabel('AdminUserValidationMsg.FormValidationForRequiredFields'))
    }
  }, [errorOnUpdate])

  

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Typography variant="h5" align="center" sx={{ fontWeight: "bolder" }}>
          {fetchAdminUserDetailsLabel("AdminUserDetails.UpdateAdminUser")}
        </Typography>

        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems="center"
          spacing={1}
          m={1}
        >
          <Button
            variant="outlined"
            size="small"
            component={Link}
            to={adminUserViewPath}
          >
           {fetchAdminUserDetailsLabel('AdminUserDetails.AdminUsers')}
          </Button>
        </Stack>

        <Box
          component="form"
          noValidate
          autoComplete="off"
          onSubmit={rhfFormInstance.handleSubmit(onSubmit)}
        >
          <MpgItem sx={{ padding: { xs: "20px" } }}>
            <Typography
              variant="h6"
              align="center"
              sx={{ fontWeight: "bolder" }}
            >
             { adminUserCMSData?.pageContent["AdminUserDetails"]?.Title}
            </Typography>

            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={6}>
                <MpgInput
                  rhfFormInstance={rhfFormInstance}
                  name={"first_name"}
                  label={fetchAdminUserDetailsLabel('AdminUserDetails.FirstName')}
                  fullWidth
                  disabled
                  required
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6}>
                <MpgInput
                  rhfFormInstance={rhfFormInstance}
                  name={"last_name"}
                  label={fetchAdminUserDetailsLabel('AdminUserDetails.LastName')}
                  fullWidth
                  disabled
                  required
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6}>
                <MpgInput
                  rhfFormInstance={rhfFormInstance}
                  name={"preferred_name"}
                  label={fetchAdminUserDetailsLabel('AdminUserDetails.Preferred Name')}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6}>
                <MpgInput
                  rhfFormInstance={rhfFormInstance}
                  name={"email"}
                  label={fetchAdminUserDetailsLabel('AdminUserDetails.Email')}
                  fullWidth
                  disabled
                  required
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6}>
                <MpgInput
                  rhfFormInstance={rhfFormInstance}
                  name={"affiliate_email"}
                  label={fetchAdminUserDetailsLabel('AdminUserDetails.AffiliateEmailAddress')}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6}>
                <MpgInput
                  rhfFormInstance={rhfFormInstance}
                  name={"preferred_number"}
                  label={fetchAdminUserDetailsLabel('AdminUserDetails.PreferredNumber')}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6}>
                <MpgAutocompleteSingle
                  rhfFormInstance={rhfFormInstance}
                  name={"time_zone"}
                  label={fetchAdminUserDetailsLabel('AdminUserDetails.TimeZone')}
                  fullWidth
                  optionList={timezonesAutocompleteList || []}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6}>
                <MpgAutocompleteSingle
                  rhfFormInstance={rhfFormInstance}
                  name={"country_user_details"}
                  label={fetchAdminUserDetailsLabel('AdminUserDetails.Country')}
                  fullWidth
                  optionList={countryListByLocaleAutocompleteList || []}
                  onChangeExtraHandler={(e) => {
                    setValue("application_language", "")
                    setValue("service_office_user_details", "")
                    setValue("time_zone_cronofy", "")
                  }}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6}>
                <MpgAutocompleteSingle
                  rhfFormInstance={rhfFormInstance}
                  name={"application_language"}
                  label={fetchAdminUserDetailsLabel('AdminUserDetails.ApplicationLanguage')}
                  optionList={countrySpLangAutocompleteList || []}

                  disabled={!!disabledApplicationLanguage}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6}>
                <MpgAutocompleteSingle
                  rhfFormInstance={rhfFormInstance}
                  name={"service_office_user_details"}
                  label={fetchAdminUserDetailsLabel('AdminUserDetails.ServiceOffice')}
                  optionList={serviceOfficeListForUserDetailsAutocompleteList || []}
                  fullWidth
                  disabled={!!disabledServiceOfficeUserDetails}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6}>
                <MpgAutocompleteSingle
                  rhfFormInstance={rhfFormInstance}
                  name={"status"}
                  label={fetchAdminUserDetailsLabel('AdminUserDetails.Status')}
                  optionList={adminUserStatusAutocompleteList || []}
                  fullWidth
                  required
                />
              </Grid>
            </Grid>
          </MpgItem>
          <br />

          <MpgItem sx={{ padding: { xs: "20px" } }}>
            <Typography
              variant="h6"
              align="center"
              sx={{ fontWeight: "bolder" }}
            >
             {adminUserCMSData?.pageContent["AdminUserRoles"]?.Title}
            </Typography>

            <Grid container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
            >
              <MpgCheckbox
                rhfFormInstance={rhfFormInstance}
                name={"enterprise_admin_check"}
                label={fetchAdminUserRolesLabel('AdminUserRoles.EnterpriseAdmin')}
                disabled={!!disabledIsEnterpriseAdminRoleBasedOnAccess}
                onChangeExtraHandler={(e) => {
                }}
              />
            </Grid>


            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={6}>
                <MpgAutocompleteSingle
                  rhfFormInstance={rhfFormInstance}
                  name={"candidate_portal_role"}
                  label={fetchAdminUserRolesLabel('AdminUserRoles.CandidatePortalRole')}
                  optionList={candidatePortalRolesAutocompleteList || []}
                  fullWidth
                  disabled={!!disabledCandidatePortalRoleOnEntRoleCheck || !!disabledCandidatePortalRoleBasedOnAccess}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6}>
                <MpgAutocompleteSingle
                  rhfFormInstance={rhfFormInstance}
                  name={"client_portal_role"}
                  label={fetchAdminUserRolesLabel('AdminUserRoles.ClientPortalRole')}
                  optionList={sortedClientPortalRolesAutocompleteList || []}
                  fullWidth
                  disabled={!!disabledClientPortalRoleOnEntRoleCheck || !!disabledClientPortalRoleBasedOnAccess}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6}>
                <MpgAutocompleteMulti
                  rhfFormInstance={rhfFormInstance}
                  name={"country_user_role"}
                  label={fetchAdminUserRolesLabel('AdminUserRoles.Country')}
                  fullWidth
                  optionList={countryListByLocaleAutocompleteList || []}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6}>
                <MpgAutocompleteMulti
                  rhfFormInstance={rhfFormInstance}
                  name={"service_office_user_role"}
                  label={fetchAdminUserRolesLabel('AdminUserRoles.ServiceOffice')}
                  fullWidth
                  optionList={serviceOfficeListForUserRolesAutocompleteList || []}
                  disabled={!!disabledServiceOffFromUserRoles}
                  required
                />
              </Grid>
            </Grid>
          </MpgItem>
          <br />

          {
            (!!showCoachRelatedContent) &&
            (
              <AdminUserProfileSection
                rhfFormInstance={rhfFormInstance}
                fetchAdminUserProfileLabel={fetchAdminUserProfileLabel}
                adminUserCMSData={adminUserCMSData}
              />
            )
          }

          {
            (!!showCoachRelatedContent) &&
            (
              <Fragment>


                <MpgItem sx={{ padding: { xs: "20px" } }}>
                  <Typography
                    variant="h6"
                    align="center"
                    sx={{ fontWeight: "bolder" }}
                  >
                      {adminUserCMSData?.pageContent["CronofySection"]?.Title}
                  </Typography>

                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={6}>
                      <MpgAutocompleteSingle
                        rhfFormInstance={rhfFormInstance}
                        name={"time_zone_cronofy"}
                        label={fetchCronofySectionLabel('CronofySection.TimeZone')}
                        optionList={cronofyTimeZoneAutocompleteList || []}
                        fullWidth
                        disabled={!!disabledTimeZoneCronofy}
                        required
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                      <MpgAutocompleteSingle
                        rhfFormInstance={rhfFormInstance}
                        name={"service_account_name_cronofy"}
                        label={fetchCronofySectionLabel('CronofySection.ServiceAccountName')}
                        optionList={serviceAccountDataAutocompleteList || []}
                        fullWidth
                        required
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                      <MpgAutocompleteMulti
                        rhfFormInstance={rhfFormInstance}
                        name={"available_days"}
                        label={fetchCronofySectionLabel('CronofySection.AvailableDays')}
                        fullWidth
                        optionList={weekDaysAutocompleteList || []}
                        required
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                      <MpgAutocompleteSingle
                        rhfFormInstance={rhfFormInstance}
                        name={"working_hours_start_time"}
                        label={fetchCronofySectionLabel('CronofySection.WorkingHrsStart')}
                        optionList={hoursListAutocompleteList || []}
                        fullWidth
                        required
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                      <MpgAutocompleteSingle
                        rhfFormInstance={rhfFormInstance}
                        name={"working_hours_end_time"}
                        label={fetchCronofySectionLabel('CronofySection.WorkingHrsEnd')}
                        optionList={hoursListAutocompleteList || []}
                        fullWidth
                        required
                      />
                    </Grid>
                  </Grid>
                </MpgItem>
                <br />
              </Fragment>
            )
          }

          <Stack
            direction={{ xs: "column", sm: "row" }}
            justifyContent={"space-evenly"}
            mt={3}
          >
            <Button
              variant="outlined"
              type="submit"
              size="small"
              disabled={!!disableUpdateAdminUserButton}
            >
             {fetchAdminUserDetailsLabel('AdminUserDetails.UpdateAdminUser')}
            </Button>
          </Stack>
        </Box>
        {/** error dialog on create action */}
        <MpgErrorDialog
          open={!!isErrorOnUpdate}
          title={`${!!isErrorOnUpdate && !!errorTitle ? errorTitle : ""}`}
          content={`${!!isErrorOnUpdate && !!errorContent ? errorContent : ""}`}
        />

        <MpgLoadingDialog
          open={!!isLoadingOnUpdate}
        />

      </Box >
    </>
  );
};

export default EditAdminUser;
